import { computed } from "vue"

export const setupLoading = ({ containerState, currentPageState }) => {
  const isLoading = computed(() => {
    return (
      !containerState.width.value ||
      !containerState.height.value ||
      !currentPageState.imageUrl.value ||
      !currentPageState.width.value ||
      !currentPageState.height.value
    )
  })

  return {
    isLoading
  }
}
